import { Controller } from "@hotwired/stimulus"

const SCROLL_END_DELAY = 120

export default class extends Controller {
  static targets = ["indicator", "item", "next", "previous", "track"]
  static values = { interval: { type: Number, default: 0 }, visibleCount: { type: Number, default: 1 } }

  connect() {
    this.currentIndex = 0
    const scrollBehavior = this.trackTarget.style.scrollBehavior
    this.trackTarget.style.scrollBehavior = "auto"
    this.trackTarget.scrollLeft = 0
    this.trackTarget.style.scrollBehavior = scrollBehavior
    this.itemTargets.forEach(item => {
      item.querySelectorAll("img").forEach(image => image.draggable = false)
    })
    this.updateIndicators()
    this.startCycling()
    this.element.dataset.carouselReady = "true"
  }

  disconnect() {
    this.stopCycling()
    window.clearTimeout(this.scrollTimer)
    delete this.element.dataset.carouselReady
  }

  next() {
    this.goTo(this.currentIndex + 1)
  }

  prev() {
    this.goTo(this.currentIndex - 1)
  }

  select(event) {
    event.preventDefault()
    this.goTo(event.params.index)
  }

  pause() {
    this.stopCycling()
  }

  resume() {
    this.startCycling()
  }

  scroll() {
    this.stopCycling()
    window.clearTimeout(this.scrollTimer)
    this.scrollTimer = window.setTimeout(() => {
      this.currentIndex = this.closestItemIndex()
      this.updateIndicators()
      this.startCycling()
    }, SCROLL_END_DELAY)
  }

  goTo(index) {
    if (this.itemTargets.length < 2) return

    if (this.visibleCountValue > 1) {
      const maxIndex = this.itemTargets.length - this.visibleCountValue
      this.currentIndex = Math.max(0, Math.min(Number(index), maxIndex))
    } else {
      this.currentIndex = (Number(index) + this.itemTargets.length) % this.itemTargets.length
    }
    this.trackTarget.scrollTo({ left: this.itemTargets[this.currentIndex].offsetLeft })
    this.updateIndicators()
  }

  closestItemIndex() {
    return this.itemTargets.reduce((closestIndex, item, index) => {
      const closestDistance = Math.abs(this.itemTargets[closestIndex].offsetLeft - this.trackTarget.scrollLeft)
      const distance = Math.abs(item.offsetLeft - this.trackTarget.scrollLeft)
      return distance < closestDistance ? index : closestIndex
    }, 0)
  }

  updateIndicators() {
    this.itemTargets.forEach((item, index) => item.classList.toggle("active", index === this.currentIndex))
    this.indicatorTargets.forEach((indicator, index) => {
      const active = index === this.currentIndex
      indicator.classList.toggle("active", active)
      indicator.setAttribute("aria-current", active.toString())
    })
    this.updateControls()
  }

  updateControls() {
    if (this.visibleCountValue <= 1) return

    const maxIndex = Math.max(0, this.itemTargets.length - this.visibleCountValue)
    if (this.hasPreviousTarget) this.previousTarget.disabled = this.currentIndex === 0
    if (this.hasNextTarget) this.nextTarget.disabled = this.currentIndex >= maxIndex
  }

  startCycling() {
    if (this.intervalValue <= 0 || this.itemTargets.length < 2 || this.cycleTimer) return

    this.cycleTimer = window.setInterval(() => this.next(), this.intervalValue)
  }

  stopCycling() {
    window.clearInterval(this.cycleTimer)
    this.cycleTimer = null
  }
}
